import {HOSTING_ENDPOINT} from "./utils/url_constants";

export const msalConfig = {
    auth: {
        clientId: 'aea2a581-3f0e-49ba-a678-781c80570d39',
        authority: 'https://login.microsoftonline.com/e707f645-7111-48d6-8c2f-ae3c1756e1a7',
        redirectUri: HOSTING_ENDPOINT
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['api://aea2a581-3f0e-49ba-a678-781c80570d39/access_as_user'],
};